<!--卡变更日志-->
<template>
  <div  class="app-container">
    <!--    查询条件区域-->
    <div class="title-container" shadow="never">
      <div class="title-con">
        <i class="el-icon-search"></i>
        <span style="margin-left: 5px;">筛选搜索</span>
      </div>
    </div>
    <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
      <div class="filter-container" style="margin-top: 10px">
        <el-form :inline="true" :model="queryParam" label-width="100px">
          <el-form-item label="接收手机号:">
            <el-input v-model="queryParam.recvPhone" placeholder="输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="会员卡号:">
            <el-input v-model="queryParam.userPhone" placeholder="输入卡号"></el-input>
          </el-form-item>
          <el-form-item label="会员姓名:">
            <el-input v-model="queryParam.childName" placeholder="输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="发送日期:">
            <el-date-picker
              v-model="queryParam.sendDay"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="button-container" style="margin-top: 0px">
        <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
      </div>
    </el-card>
    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table ref="tableData"
                style="width: 100%"
                :data="tableData"
                max-height="520"
                v-loading="listLoading" border
                highlight-current-row
                :header-cell-style="{'text-align':'center'}"
                :cell-style="{'text-align':'center'}">
        <el-table-column prop="name" label="姓名" width="120"></el-table-column>
        <el-table-column prop="sender" label="发送人" width="120"></el-table-column>
        <el-table-column prop="sendTime" label="发送时间" width="180"></el-table-column>
        <el-table-column prop="phone" label="手机号"width="150"></el-table-column>
        <el-table-column prop="content" label="发送内容" width="480"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :page-sizes="queryParam.pageSizes"
        :total="queryParam.totalPage">
      </el-pagination>
    </div>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }

</style>
<script>

  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {queryVccConsume} from "../../../api/ConsumeRecord";

  export default {

    data() {
      return {
        listLoading: true,
        queryParam:{
          recvPhone:"",
          userPhone: '',
          childName:"",
          teacherName:"",
          storeReleaseCardId:null,
          sendDay:"",
          //分页查询
          pageNum :1 ,//当前第几页
          totalPage :1, //总共页数
          pageSize : 10,
          pageSizes:[10,20,50,100],
        },



        //表单结果
        tableData: [
        ],




      }
    },
    created(){
      this.flechList();

    },
    mounted() {

    },
    methods: {

      getStoreLessonTemplate(data){


      },
      flechList(){
        this.listLoading = true;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId,

          recvPhone:this.queryParam.recvPhone,
          userPhone: this.queryParam.userPhone,
          childName:this.queryParam.childName,
          storeReleaseCardId:this.queryParam.storeReleaseCardId,
          teacherName:this.queryParam.teacherName,
          sendDay:this.queryParam.sendDay,
          pageNum : this.queryParam.pageNum ,//当前第几页
          pageSize :  this.queryParam.pageSize
        }
        queryVccConsume(param).then(response =>
        {
          this.listLoading = false;
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          this.queryParam.totalPage = date.total;
          this.refreshData(date.list);

        })
      },
      //刷新页面数据
      refreshData(list){

        if (commonUtils.isObjectNull(list)){
          return;
        }

        let tableDataList = [];
        for (let i = 0;i< list.length;++i){

          let data = {

            id: list[i].id,
            storeFrontId: list[i].storeFrontId,
            cardId:list[i].cardId,
            name:list[i].name,
            sender:list[i].sender,
            sendTime:list[i].sendTime,
            phone:list[i].phone,
            content:list[i].content,
            remark: list[i].remark,
          };
          tableDataList.push(data);
        }

        this.tableData = tableDataList;
      },
      //点击查询按钮
      onBtnSearch(){
        this.flechList();
      },

      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.flechList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.flechList();
      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/consume/vcc-consume/index.vue